import React, { useState, useEffect } from "react";
import { loader } from "graphql.macro";
import { simpleGTMDataLayer, soundPlay } from "../../utils/utilities";
import { executeGraphqlMutation } from "../../graphql/api";
import { useDispatch, useSelector } from "react-redux";
import "./MyPreferences.css";
import {
  SABox,
  SAButton,
  SAColumns,
  SAIcon,
  SAIcons,
  SASelect,
} from "@saux/design-system-react";
import Switch from "react-switch";
import snackbarOpen from "../../store/action-creators/snackbarActionCreators";
import { SNACKBAR } from "../../utils/constants";
import { PlayArrowOutlined } from "@material-ui/icons";
import { getAdjusterSchedule } from "../../store/actions/userActions";
import store from "../../store";
const updateAdjusterSettings = loader(
  "../../graphql/mutations/updateAdjusterSettings.graphql"
);

export default function MyPreferences(props: any) {
  const [checkedSoundNotification, setCheckedNotification] = useState<boolean>(
    props.notificationSound !== ""
  );
  const user = useSelector((state: any) => state.user);

  const handleSoundPreview = () => {
    soundPlay(props.notificationSound);
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Preview-Sound-Notifications-Click`,
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: `Preview Sound for Notification`,
      event_value: `${user.fullName} previewed ${props.notificationSound} sound for notification.`
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Preview-Sound-Notifications-Click-Snowplow`,
      event_action: 'Button Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Preview Sound for Notification`,
      event_value: `${user.fullName} previewed ${props.notificationSound} sound for notification.`
    });
  };
  const handleSoundNotificationChange = (e: any) => {
    props.setNotificationSound(e.target.value);
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Sound-Notifications-Dropdown-Click`,
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: `Select Sound for Notification`,
      event_value: `${user.fullName} selected ${e.target.value} sound for notification.`
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Sound-Notifications-Dropdown-Click-Snowplow`,
      event_action: 'Button Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Select Sound for Notification`,
      event_value: `${user.fullName} selected ${e.target.value} sound for notification.`
    });
  };

  const dispatch = useDispatch();
  const handlePreferencesSave = () => {
    executeGraphqlMutation(updateAdjusterSettings, {
      adjusterId: user.email,
      settings: {
        notificationSoundValue: props.notificationSound,
      },
    })
      .then((res: any) => {
        if (res.data.updateAdjusterSettings.status === "Success")
          console.log("success");
        dispatch(getAdjusterSchedule(
          { adjusterId: user.email },
          (response: any) => {
            console.log(response);
          }));

        const notifySound = checkedSoundNotification ? `Your notification sound has been set to ${props.notificationSound}` :
          "Your notification sound has been turned off";
        dispatch(
          snackbarOpen({
            open: true,
            title: "Notification preferences updated",
            message: notifySound,
            type: SNACKBAR.SUCCESS,
          })
        );
        props.setDefaultIndex(0);
        props.closeModal(false);
        simpleGTMDataLayer({
          csrId: user.userName,
          event: `Save-Sound-Notifications-Click`,
          event_action: 'Button Click',
          event_category: window.location.pathname,
          event_label: `Save Sound for Notification`,
          event_value: `${user.fullName} selected ${props.notificationSound} sound for notification.`
        });
        simpleGTMDataLayer({
          csrId: user.userName,
          event: `Save-Sound-Notifications-Click-Snowplow`,
          event_action: 'Button Click',
          event_category: window.location.pathname + "/Snowplow",
          event_label: `Save Sound for Notification`,
          event_value: `${user.fullName} selected ${props.notificationSound} sound for notification.`
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          snackbarOpen({
            open: true,
            title: "Something Went Wrong",
            message:
              "Notification preferences failed  to update, please try again later",
            type: SNACKBAR.ERROR,
          })
        );
      });
  };
  useEffect(() => {
    if (!checkedSoundNotification) {
      props.setNotificationSound("");
    }
    else {
      if (props.notificationSound === "") {
        props.setNotificationSound("alert_simple")
      }
      else {
        props.setNotificationSound(props.notificationSound)
      }
    }
  }, [checkedSoundNotification]);

  const handlePreferencesCancel = () => {
    // if(props.notificationSound ==""){
    //   props.setNotificationSound("alert_simple");
    // }
    // else{
    dispatch(
      getAdjusterSchedule(
        { adjusterId: user.email },
        (res: any) => {
          props.setNotificationSound(
            res.data.getAdjusterSchedule[0].adjusterSetting
              .notificationSoundValue
          );
        }
      ));
    // }
    props.setDefaultIndex(0);
    props.closeModal(false);
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Cancel-Sound-Notifications-Click`,
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: `Cancel Sound for Notification`,
      event_value: `${user.fullName} cancelled sound notification changes.`
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Cancel-Sound-Notifications-Click-Snowplow`,
      event_action: 'Button Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Cancel Sound for Notification`,
      event_value: `${user.fullName} cancelled sound notification changes.`
    });
  };

  const handleSoundNotificationSwitchChange = () => {
    setCheckedNotification(!checkedSoundNotification);
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Sound-Notifications-Click`,
      event_action: 'Toggle Click',
      event_category: window.location.pathname,
      event_label: `Sound Notification toggle turn on/off`,
      event_value: `${user.fullName} turned ${checkedSoundNotification ? "off" : "on"} sound notifications.`
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Sound-Notifications-Click-Snowplow`,
      event_action: 'Toggle Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Sound Notification toggle turn on/off`,
      event_value: `${user.fullName} turned ${checkedSoundNotification ? "off" : "on"} sound notifications.`
    });
  };

  const handleBrowserNotificationSwitchChange = () => {
    props.setIsBrowserNotificationDisabled(false);
  };

  return (
    <div>
      <SABox px="medium" py="small">
        <span className="my-preferences--notification--heading">
          Notification Preferences
        </span>
      </SABox>
      {/* <SABox display="flex">
        <SAColumns columns={[5]} spacing="medium">
          <SABox px="xs" py="small">
            <span className="my-preferences--notification--label">
              Browser Notification
            </span>
          </SABox>
          <SABox px="large" py="small">
            <Switch
              onChange={handleBrowserNotificationSwitchChange}
              checked={props.isBrowserNotificationDisabled}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#0173C6"
              offColor="#666666"
              height={25}
              width={45}
              borderRadius={25}
            />
          </SABox>
        </SAColumns>
      </SABox>{" "} */}
      <SABox display="inline">
        <SAColumns columns={[5]} spacing="medium">
          <SABox
            SABox
            px="large"
            py="large"
            font-size={18}
            font-weight="fontWeightBold"
          >
            <span className="my-preferences--notification--label">
              Sound Notifications
            </span>
          </SABox>
          <SABox px="large" py="large">
            <Switch
              onChange={handleSoundNotificationSwitchChange}
              checked={checkedSoundNotification}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor="#0173C6"
              offColor="#666666"
              height={25}
              width={45}
              borderRadius={25}
            />
          </SABox>
        </SAColumns>
      </SABox>
      {checkedSoundNotification ? (
        <SABox display="inline">
          <SAColumns columns={[6]} spacing="medium">
            <SABox px="large" py="medium">
              <SASelect
                label="Notification sound"
                id="productType"
                fullWidth={true}
                color={"white"}
                options={[
                  { label: "alert_simple", value: "alert_simple" },
                  { label: "ambient", value: "ambient" },
                  { label: "decorative-01", value: "decorative-01" },
                  { label: "decorative-02", value: "decorative-02" },
                  { label: "high-intensity", value: "high-intensity" },
                  { label: "simple-01", value: "simple-01" },
                  { label: "simple-02", value: "simple-02" },
                  { label: "sonar", value: "sonar" }
                ]}
                value={props.notificationSound}
                onChange={handleSoundNotificationChange}
                style={{
                  fontSize: "16px",
                  fontFamily: "Lato",
                  fontWeight: "400",
                }}
                className="select_SA"
              />
            </SABox>
            <SABox px="medium" pt="large" display="inline">
              <SAButton
                style={{
                  color: "#0173C6",
                  backgroundColor: "white",
                  fontSize: 16,
                }}
                label="preview"
                variant="small-outline"
                onClick={handleSoundPreview}
                startIcon={<PlayArrowOutlined />}
              />
            </SABox>
          </SAColumns>
        </SABox>
      ) : null}
      <SABox display="flex">
        <SAButton
          style={{
            color: "black",
            backgroundColor: "white",
            fontSize: 16,
            display: "inline-block",
            marginTop: "10%",
            marginLeft: "80%",
            marginBottom: "3%",
          }}
          label="cancel"
          variant="small"
          onClick={handlePreferencesCancel}
        />
        <SAButton
          style={{
            color: "white",
            backgroundColor: "#65A100",
            fontSize: 16,
            margin: "10px",
            marginTop: "10%",
            display: "inline-block",
            marginBottom: "3%",
          }}
          label="save"
          variant="small"
          onClick={handlePreferencesSave}
        />
      </SABox>
    </div>
  );
}

